<template>
  <div>
    <vue-plotly
      v-if="chartData"
      :data="chartData"
      :layout="layout"
      class="chart"
    />
  </div>
</template>

<script>
import VuePlotly from "@statnett/vue-plotly";

export default {
  name: "OZGActivityCountyMap",
  props: [
    "statusType",
    "statusId",
    "serviceId",
    "categoryId",
    "leadingInstitutionID",
    "applicableLaws",
    "showLegend",
    "referenceImplementation"
  ],
  data() {
    return {
      aggregateOzgTimelineAsCountyHeatmap: [],
      chartData: [],

      layout: {
        mapbox: {
          style: "stamen-toner",
          center: { lon: 10.01, lat: 51.15 },
          zoom: 5
        },
        height: 700
      }
    };
  },
  components: { VuePlotly },

  apollo: {
    $client: "ozgClient",

    aggregateOzgTimelineAsCountyHeatmap: {
      query() {
        return require("../../graphql/OZGTimelineMonthStatusUpdateAsHeatmap.gql");
      },
      variables: function() {
        return {
          statusId: this.$props.statusId,
          serviceId: this.$props.serviceId,
          categoryId: this.$props.categoryId,
          leadingInstitutionID: this.$props.leadingInstitutionID,
          statusType: this.$props.statusType,
          applicableLaws: this.$props.applicableLaws,
          referenceImplementation: this.$props.referenceImplementation
        };
      }
    }
  },
  methods: {
    renderGraph: function(newVal) {
      {
        var counties = [
          "Baden-Württemberg",
          "Bayern",
          "Berlin",
          "Brandenburg",
          "Bremen",
          "Hamburg",
          "Hessen",
          "Mecklenburg-Vorpommern",
          "Niedersachsen",
          "Nordrhein-Westfalen",
          "Rheinland-Pfalz",
          "Saarland",
          "Sachsen-Anhalt",
          "Sachsen",
          "Schleswig-Holstein",
          "Thüringen"
        ];
        var aggregation = {
          type: "choroplethmapbox",
          name: "",
          geojson: require("../../assets/german_counties.geo.json"),
          hovertemplate: "%{text.county} <b>%{z}</b>",
          text: [
            { county: "Baden-Württemberg", sum: 0, no_information: 0 },
            { county: "Bayern", sum: 0, no_information: 0 },
            { county: "Berlin", sum: 0, no_information: 0 },
            { county: "Brandenburg", sum: 0, no_information: 0 },
            { county: "Bremen", sum: 0, no_information: 0 },
            { county: "Hamburg", sum: 0, no_information: 0 },
            { county: "Hessen", sum: 0, no_information: 0 },
            { county: "Mecklenburg-Vorpommern", sum: 0, no_information: 0 },
            { county: "Niedersachsen", sum: 0, no_information: 0 },
            { county: "Nordrhein-Westfalen", sum: 0, no_information: 0 },
            { county: "Rheinland-Pfalz", sum: 0, no_information: 0 },
            { county: "Saarland", sum: 0, no_information: 0 },
            { county: "Sachsen-Anhalt", sum: 0, no_information: 0 },
            { county: "Sachsen", sum: 0, no_information: 0 },
            { county: "Schleswig-Holstein", sum: 0, no_information: 0 },
            { county: "Thüringen", sum: 0, no_information: 0 }
          ],
          locations: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
          z: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          zmin: 0,
          zmax: 50,
          colorscale: [
            [0, "rgb(0,68,27)"],
            [0.125, "rgb(0,109,44)"],
            [0.25, "rgb(35,139,69)"],
            [0.375, "rgb(65,171,93)"],
            [0.5, "rgb(116,196,118)"],
            [0.625, "rgb(161,217,155)"],
            [0.8, "rgb(199,233,192)"],
            [0.95, "rgb(229,245,224)"],
            [1, "rgb(255,255,255)"]
          ],
          reversescale: true,

          colorbar: {
            y: 0,
            yanchor: "bottom",
            title: { text: "", side: "right" }
          }
        };
        for (var x in newVal) {
          console.log(newVal[x]);
          aggregation.z[counties.indexOf(newVal[x].county.name)] +=
            newVal[x].count;
        }
        console.log(aggregation);

        this.chartData = [aggregation];
      }
    }
  },
  watch: {
    aggregateOzgTimelineAsCountyHeatmap: function(newVal) {
      this.renderGraph(newVal);
    }
  }
};
</script>

<style scoped></style>

<style scoped lang="scss"></style>
